module.exports = __webpack_public_path__ + "img/skills-nova-sor-3.f77b3ae5.png";